import React from "react";

export const HeaderComp = (props) => {
  return (
    <div className="card border-0 rounded-0">
      <div className="container py-4">
        <div className="row">
          <div className="col-md-12 d-flex align-items-center mb-md-0 mb-3">
            <h3>{props.title}</h3>
          </div>
        </div>
      </div>
    </div>
  );
};
